import type { FaireBrandEntity } from "../../entity_types/brand";

export const be_light_candle_re: FaireBrandEntity = {
  token: "be-light-candle-re",
  type: "brand",
  name: "Be Light Candle Re",
  minimumOrderDollars: 100,
  rating: 4.6,
  reviewCount: 67,
  isTopShop: false,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
